import { Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';
import { appLinkConstants, customerLinkConstants, managementLinkConstants } from '../constants';

/**
 * Extends the default ngx-translate parser to automatically inject
 * global interpolation params into every translation.
 *
 * Usage in translation files:
 * "some.key": "Mehr Infos: {{gesamtbetriebsvereinbarungLink}}"
 *
 * No need to pass params in the template — the values are always available.
 */
@Injectable()
export class GlobalTranslateParser extends TranslateDefaultParser {
    private readonly globalParams: Record<string, unknown> = {
        ...appLinkConstants,
        ...customerLinkConstants,
        ...managementLinkConstants
    };

    public override interpolate(
        expr: string | ((...args: unknown[]) => string),
        params?: Record<string, unknown>
    ): string | undefined {
        return super.interpolate(expr, { ...this.globalParams, ...params });
    }
}
